import { Device, Document, RoadmapCard, RoadmapTask } from "@models";
import { RoadmapVisibilityConditions } from "src/stores/models/roadmap-visibility-conditions";
import {
  hasElectrical,
  hasHardware,
  hasSoftware,
  isClass1,
  isClass2a,
  isClass2b,
  isClass3,
} from "src/utils/device";
import { mapDocumentVersionsToDataKeys } from "src/utils/tasks";

export const isCardVisible = (
  card: RoadmapCard,
  device: Device,
  documents?: Document[]
): boolean => {
  return isEntityVisible(
    card.visibilityConditions || undefined,
    device,
    documents
  );
};

export const isTaskVisible = (
  task: RoadmapTask,
  device: Device,
  documents?: Document[]
): boolean => {
  return isEntityVisible(
    task.visibilityConditions || undefined,
    device,
    documents
  );
};

export const isEntityVisible = (
  conditions: RoadmapVisibilityConditions | undefined,
  device: Device,
  documents?: Document[]
) => {
  if (!conditions || Object.keys(conditions).length === 0) {
    return true;
  }

  let deviceClassConditions = false;

  if (
    conditions.isClass1 !== undefined ||
    conditions.isClass2a !== undefined ||
    conditions.isClass2b !== undefined ||
    conditions.isClass3 !== undefined
  ) {
    if (!documents) {
      throw new Error(
        "Documents are required to check device class conditions"
      );
    }

    const availableDataKeys = mapDocumentVersionsToDataKeys(documents);

    deviceClassConditions =
      (conditions.isClass1 !== undefined &&
        conditions.isClass1 === isClass1(availableDataKeys)) ||
      (conditions.isClass2a !== undefined &&
        conditions.isClass2a === isClass2a(availableDataKeys)) ||
      (conditions.isClass2b !== undefined &&
        conditions.isClass2b === isClass2b(availableDataKeys)) ||
      (conditions.isClass3 !== undefined &&
        conditions.isClass3 === isClass3(availableDataKeys));
  }

  return (
    deviceClassConditions ||
    (conditions.hasElectricalComponent !== undefined &&
      conditions.hasElectricalComponent === hasElectrical(device)) ||
    (conditions.hasSoftware !== undefined &&
      conditions.hasSoftware === hasSoftware(device)) ||
    (conditions.hasHardware !== undefined &&
      conditions.hasHardware === hasHardware(device)) ||
    (conditions.isMDR !== undefined && conditions.isMDR === device.isMDR) ||
    (conditions.isIVDR !== undefined && conditions.isIVDR === device.isIVDR) ||
    (conditions.isFDA !== undefined && conditions.isFDA === device.isFDA)
  );
};
